import { ChartTooltip } from '@mantine/charts';
import type { ComponentProps } from 'react';

export type UnifyChartTooltipProps = ComponentProps<typeof ChartTooltip>;

export function UnifyChartTooltip(props: UnifyChartTooltipProps): JSX.Element {
  return <ChartTooltip {...props} />;
}
